import { render, staticRenderFns } from "./BankDetailsForm.vue?vue&type=template&id=f57e7180&scoped=true&"
import script from "./BankDetailsForm.vue?vue&type=script&lang=js&"
export * from "./BankDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./BankDetailsForm.vue?vue&type=style&index=0&id=f57e7180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57e7180",
  null
  
)

export default component.exports